import { useLang } from '@/i18n';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
export default function Comp() {
    const { t } = useLang('theProduct.BannerA');
    const dataA: EcoBannerProps = {
        layout: 'top-center',

        pc: 'https://websiteoss.ecoflow.com/upload/image/1735808667056/gray-bg.jpg',
        label: t('label'),
        labelColor: '#D11504',
        title: t('title'),
        desc: t('desc'),

        // 按钮
        lType: 'filled',
        lChildren: t('btn1'),
        lHref: 'https://www.youtube.com/embed/zsonj2HPQdM?si=2GSK67QBoFc7Azgk',
        lBtnIsYouToBe: false,

        // 按钮
        rType: 'outlined',
        rChildren: t('btn2'),
        rHref: 'https://www.youtube.com/embed/zsonj2HPQdM?si=2GSK67QBoFc7Azgk',
        rBtnIsYouToBe: true,
    };
    return (
        <>
            <EcoBanner {...dataA} />
        </>
    );
}
